import { V3Models } from "@istari/istari-client";
import { useMutation } from "@tanstack/react-query";

import clientV3SDK from "~/api/clientV3SDK";
import { modelQueryKeys } from "~/api/model/modelQueryKeys";
import { queryClient } from "~/api/queryClient";
import { resourceQueryKeys } from "~/resource/data-source/api/resource-query-options";

type CreateResourceParams = {
  file: File;
  displayName: string;
  description?: string;
  externalIdentifier?: string;
  resourceType: V3Models.ResourceTypeDto;
};

export function useCreateResource() {
  return useMutation({
    mutationFn: (params: CreateResourceParams) =>
      clientV3SDK.createResourceFromFile({
        file: params.file,
        resource: {
          resourceType: params.resourceType,
          displayName: params.displayName,
          description: params.description,
          externalIdentifier: params.externalIdentifier,
        },
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: resourceQueryKeys.all() });
      void queryClient.invalidateQueries({ queryKey: modelQueryKeys.all });
      void queryClient.invalidateQueries({ queryKey: ["modelsList"] });
    },
    meta: { skipGlobalInvalidation: true },
  });
}
